import React, { memo, useState } from 'react'
import FinalizationHeader from './components/FinalizationHeader'
import styles from './PublicLayoutFinalization.module.scss'
import { Outlet } from 'react-router-dom'
import PublicSideMenu from '../components/public-side-menu/PublicSideMenu'

type Props = {}

const PublicLayoutFinalization: React.FC<Props> = memo((props: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  function handleMenuButtonClick() {
    setMenuOpen(!menuOpen);
  }

  return (
    <>
      <FinalizationHeader onClickSideMenu={handleMenuButtonClick} />
      <div className={styles.container}>
        <Outlet />
      </div>
      <PublicSideMenu menuOpen={menuOpen} closeMenu={handleMenuButtonClick} />
    </>
  )
})

export default PublicLayoutFinalization